import PropTypes from "prop-types"

// Mui
import { Box, Stack, useTheme } from "@mui/material"

// Icons
import { ArrowDown2, ArrowUp2 } from "iconsax-react"

// ---------------------------------------|| HEADER SORT - COMPONENTS ||------------------------------------------------

const HeaderSort = ({ column, sort }) => {
  // Use Theme
  const theme = useTheme()

  return (
    <Stack direction='row' spacing={1} alignItems='center' sx={{ display: "inline-flex" }}>
      <Box>{column.render("Header")}</Box>
      {!column.disableSortBy && (
        <Stack
          sx={{ color: "secondary.light" }}
          {...(sort && { ...column.getHeaderProps(column.getSortByToggleProps()) })}
        >
          <ArrowUp2 size={12} color={theme.palette.primary.main} />
          <ArrowDown2 size={12} color={theme.palette.primary.main} />
        </Stack>
      )}
    </Stack>
  )
}

HeaderSort.propTypes = {
  column: PropTypes.any,
  sort: PropTypes.bool
}

export default HeaderSort
